module.exports = __webpack_public_path__ + "img/graph-paper-notebook_B099TGCTL1.8dd2f8f9.jpg";